import React from 'react'

import InlineSVG from 'svg-inline-react'

import ClearNightIconSrc from '~/client/static/icons/weather-icons/clear-night.svg'
import CloudyIconSrc from '~/client/static/icons/weather-icons/cloudy.svg'
import DewPointSrc from '~/client/static/icons/weather-icons/dew-point.svg'
import FogIconSrc from '~/client/static/icons/weather-icons/fog.svg'
import HumidityIconSrc from '~/client/static/icons/weather-icons/humidity.svg'
import PartlyCloudyNightIconSrc from '~/client/static/icons/weather-icons/partly-cloudy-night.svg'
import PartlyCloudyIconSrc from '~/client/static/icons/weather-icons/partly-cloudy.svg'
import RainIconSrc from '~/client/static/icons/weather-icons/rain-heavy.svg'
import ShowerIconSrc from '~/client/static/icons/weather-icons/rain-light.svg'
import SnowIconSrc from '~/client/static/icons/weather-icons/snow-cloudy.svg'
import SunnyIconSrc from '~/client/static/icons/weather-icons/sunny.svg'
import ThunderstormIconSrc from '~/client/static/icons/weather-icons/thunderstorm.svg'
import WindDirectionIconSrc from '~/client/static/icons/weather-icons/wind-direction.svg'

interface IProps {
  color?: string
  size?: number

  [key: string]: any
}

const DEFAULT_SIZE = 20
export function Humidity({ size = 12, ...props }: IProps) {
  return renderInlineSvg(HumidityIconSrc, { size, ...props })
}
export function DewPoint({ size = 12, ...props }: IProps) {
  return renderInlineSvg(DewPointSrc, { size, ...props })
}

export function PartlyCloudy({ size = 24, ...props }: IProps) {
  return renderInlineSvg(PartlyCloudyIconSrc, { size, ...props })
}
export function PartlyCloudyNight({ size = 24, ...props }: IProps) {
  return renderInlineSvg(PartlyCloudyNightIconSrc, { size, ...props })
}
export function Cloudy({ size = 24, ...props }: IProps) {
  return renderInlineSvg(CloudyIconSrc, { size, ...props })
}
export function Fog({ size = 24, ...props }: IProps) {
  return renderInlineSvg(FogIconSrc, { size, ...props })
}
export function Rain({ size = 24, ...props }: IProps) {
  return renderInlineSvg(RainIconSrc, { size, ...props })
}
export function Shower({ size = 24, ...props }: IProps) {
  return renderInlineSvg(ShowerIconSrc, { size, ...props })
}
export function Sunny({ size = 24, ...props }: IProps) {
  return renderInlineSvg(SunnyIconSrc, { size, ...props })
}
export function ClearNight({ size = 24, ...props }: IProps) {
  return renderInlineSvg(ClearNightIconSrc, { size, ...props })
}
export function Thunderstorm({ size = 24, ...props }: IProps) {
  return renderInlineSvg(ThunderstormIconSrc, { size, ...props })
}
export function Snow({ size = 24, ...props }: IProps) {
  return renderInlineSvg(SnowIconSrc, { size, ...props })
}
export function WindDirection({ size = 12, ...props }: IProps) {
  return renderInlineSvg(WindDirectionIconSrc, { size, ...props })
}

function renderInlineSvg(src: any, props: IProps): JSX.Element {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { size = DEFAULT_SIZE, color, style, ...rest } = props

  return (
    <InlineSVG
      {...rest}
      src={src}
      style={{ color, width: size, height: size, ...style }}
    />
  )
}
